import { Component, OnInit, Input } from '@angular/core';
import { BtnType } from '../../type/btnType.type';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})

export class BackButtonComponent implements OnInit {

  @Input()
  get fallbackUrl(): string { return this._fallbackUrl }
  set fallbackUrl(fallbackUrl: string) {
    this._fallbackUrl = (fallbackUrl && fallbackUrl.trim()) || '/';
  }
  private _fallbackUrl = '';

  @Input('type') type: BtnType = 'button';

  constructor(private _navigationService: NavigationService) { }

  ngOnInit() { }

  public back() {
    this._navigationService.back(this._fallbackUrl);
  }

}
